<template>
  <v-dialog
    :value="value"
    @input="$emit('input', false)"
  >
    <v-card class="pa-0 pa-3">
      <div
        v-if="value"
        style="width: 100%; height: 800px; z-index: 0"
        id="map"
      ></div>
      <v-btn
        depressed
        color="primary"
        class="mt-3"
        @click="$emit('input', false)"
      >
        <div class="text-none">Применить</div>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
  import { v4 } from 'uuid'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'DrawZoneOnMap',

    props: {
      value: Boolean,
      item: {
        type: Object,
        required: true
      }
    },

    data: () => ({
      drawnItems: null,
      layerUuidMap: new Map()
    }),

    computed: {
      participantFilters: {
        get() {
          return this.item.participant_filters || {}
        },
        set(value) {
          this.$set(this.item, 'participant_filters', value)
        }
      },
      areas: {
        get() {
          return (
            this.participantFilters.areas || {
              type: 2, // DELIVERY_ADDRESSES по умолчанию
              items: []
            }
          )
        },
        set(value) {
          this.$set(this.participantFilters, 'areas', value)
        }
      }
    },

    methods: {
      initMap() {
        setTimeout(() => {
          this.$L.initMap('map', [54.5223, 20.7039])
          this.drawnItems = new L.FeatureGroup()
          this.$L.map.addLayer(this.drawnItems)
          this.addMapControls()
          this.addMapEventsListeners()
          this.drawExistingZones()
        })
      },

      addMapControls() {
        this.$L.map.addControl(
          new L.Control.Draw({
            edit: { featureGroup: this.drawnItems },
            draw: {
              marker: false,
              circlemarker: false,
              polyline: false,
              circle: true,
              rectangle: false
            }
          })
        )
      },

      createCircleArea({ lat, lng, radius }) {
        return {
          type: 1, // CIRCLE
          uuid: v4(),
          lat,
          lng,
          radius
        }
      },

      createPolygonArea(coords) {
        return {
          type: 2, // POLYGON
          uuid: v4(),
          coords
        }
      },

      handleLayerCreated(e) {
        const { layer } = e
        layer.options.color = '#fab400'
        this.drawnItems.addLayer(layer)

        const data = layer.toGeoJSON()
        const isCircle = data.geometry.type === 'Point'

        let areaItem
        if (isCircle) {
          const { lat, lng } = layer.getLatLng()
          areaItem = this.createCircleArea({
            lat,
            lng,
            radius: layer.getRadius()
          })
        } else {
          const coords = data.geometry.coordinates[0].map(([lng, lat]) => ({
            lat,
            lng
          }))
          areaItem = this.createPolygonArea(coords)
        }

        // Добавляем новый item в существующий areas
        this.areas = {
          ...this.areas,
          items: [...this.areas.items, areaItem]
        }
        this.layerUuidMap.set(layer._leaflet_id, areaItem.uuid)
      },

      handleLayerEdited() {
        const newItems = this.drawnItems.getLayers().map(layer => {
          const uuid = this.layerUuidMap.get(layer._leaflet_id)
          const data = layer.toGeoJSON()

          if (layer.getRadius) {
            const { lat, lng } = layer.getLatLng()
            const item = this.createCircleArea({
              lat,
              lng,
              radius: layer.getRadius()
            })
            item.uuid = uuid // Сохраняем существующий UUID
            return item
          }

          const coords = data.geometry.coordinates[0].map(([lng, lat]) => ({
            lat,
            lng
          }))
          const item = this.createPolygonArea(coords)
          item.uuid = uuid // Сохраняем существующий UUID
          return item
        })

        this.areas = {
          ...this.areas,
          items: newItems
        }
      },

      handleLayerDeleted(e) {
        const deletedUuids = new Set(
          Array.from(e.layers.getLayers())
            .map(layer => this.layerUuidMap.get(layer._leaflet_id))
            .filter(Boolean)
        )

        this.areas = {
          ...this.areas,
          items: this.areas.items.filter(item => !deletedUuids.has(item.uuid))
        }

        // Очищаем удаленные слои из карты соответствий
        e.layers.getLayers().forEach(layer => {
          this.layerUuidMap.delete(layer._leaflet_id)
        })
      },

      addMapEventsListeners() {
        this.$L.map.on(L.Draw.Event.CREATED, this.handleLayerCreated)
        this.$L.map.on(L.Draw.Event.EDITED, this.handleLayerEdited)
        this.$L.map.on(L.Draw.Event.DELETED, this.handleLayerDeleted)
      },

      drawExistingZones() {
        if (!this.areas?.items?.length) return

        this.layerUuidMap.clear()

        this.areas.items.forEach(item => {
          // Добавляем UUID если его нет (для обратной совместимости)
          if (!item.uuid) {
            item.uuid = v4()
          }

          let layer

          if (item.type === 1) {
            // CIRCLE
            layer = L.circle([item.lat, item.lng], {
              radius: item.radius,
              color: '#fab400'
            })
          } else if (item.type === 2) {
            // POLYGON
            layer = L.polygon(
              item.coords.map(({ lat, lng }) => [lat, lng]),
              {
                color: '#fab400'
              }
            )
          }

          if (layer) {
            this.drawnItems.addLayer(layer)
            this.layerUuidMap.set(layer._leaflet_id, item.uuid)
          }
        })

        if (this.drawnItems.getLayers().length) {
          this.$L.map.fitBounds(this.drawnItems.getBounds())
        }
      }
    },

    watch: {
      value(v) {
        if (v) {
          this.initMap()
        }
      }
    }
  })
</script>

<style scoped></style>
